
<template>
  <div>
    <b-modal size="lg" v-model="modalAbierto" hide-footer centered hide-header >
      <div class="d-flex justify-content-between mb-3 align-items-center">
        <div>
          <em class="fa fa-envelope" style="color:#044169; font-size: 16px; width: 18px; margin-bottom: -4px;"></em>
          <span style="color:#044169; font-weight: 600; font-size: 14px" > Configuración de plazos para impresión </span>
        </div>
        <div>
          <button type="button" aria-label="Close" class="close" @click="$emit('cerrar')">×</button>
        </div>
      </div>

      <span>Ingrese el monto a calcular, el monto y los plazos se mostrarán en la impresión del PTI.</span>
      <div class="d-flex justify-content-center">
        <p class="mt-2" style="font-size: .9em; font-weight: bold; color: #17A2B8;">{{tituloModal}} {{inversionTotal | monedaEntero}}</p>
      </div>

      <div class="mt-1">
          <label for="nombreBusq">Monto a financiar</label>
        <div class="d-flex">
          <b-form-input
              :disabled="calculando"
              v-model="montoPagar"
              style="width: 46%"
              type="number"
              min="1"
              placeholder="$0"
              @keydown="filterJustNumber($event)"
          />
          <b-button variant="outline-primary" :disabled="calculando" class="ml-1" @click="calcularMontosPlazoFijo">Calcular</b-button>

          <em class="trash_svg ml-1" style="cursor: pointer; width: 35px;"
              v-if="calculando"
              @click="eliminarMonto"
          ></em>
        </div>
      </div>

      <div class="m-5 d-flex justify-content-center" v-if="!calculando">
        <span>Ingrese un monto para comenzar</span>
      </div>

      <div class="mt-1" v-if="calculando">
        <label for="nombreBusq">Plazos</label>
        <div class="d-flex">
          <v-select
              style="width: 46%"
              placeholder="Seleccione los plazos"
              v-model="selectedMeses"
              :options="costoMsiTdc"
              label="meses"
              item-title="meses"
              :item-value="item => item"
              multiple
              @input="handleSelectedMeses"
          ></v-select>

        </div>
      </div>

      <div class="m-5 d-flex justify-content-center" v-if="calculando && selectedMeses.length === 0">
        <span>Sin plazos seleccionados</span>
      </div>

      <div class="mt-3" v-if="selectedMeses.length > 0">
        <div class="contenedorTablaSinColor text-center m-2 " style="border-radius: 10px;">
          <b-table
              responsive
              id="tablaTDC"
              thead-tr-class="columnasTablaSinColor"
              :items="selectedMeses"
              :fields="fields"
              selectable
              class="parrafos"
              fixed
              hover>
            <template #cell(pagoMensual)="row">
              <span >{{row.item.pagoMensual | monedaEntero}}</span>
            </template>
            <template #cell(costoFinanciamiento)="row">
              <span v-if="row.item.costoFinanciamiento !== 'Sin costo'">{{row.item.costoFinanciamiento | monedaDecimales}}</span>
              <span v-else style="color: #3EBF90; font-weight: 500">{{ row.item.costoFinanciamiento }}</span>
            </template>
            <template #cell(total)="row">
              <span >{{row.item.total | monedaDecimales}}</span>
            </template>
          </b-table>

          <span style="font-size: 10px; font-weight: 500; color: #EB6228" v-if="configuracionesMsi.length === 0"
          > La clínica no tiene configuraciones de plazos fijos </span>

          <span style="font-size: 10px; font-weight: 500; color: #0069A9" v-else-if="costoMsiTdc.length === 0"
          > Por favor ingrese el "total a pagar" seguido de un enter (↵) </span>
        </div>
      </div>

      <div class="m-5 d-flex justify-content-around">
        <b-button variant="primary" :disabled="selectedMeses.length === 0"
                  style="background: var(--color-dentalia-1-v2); border-color: var(--color-dentalia-1-v2);"
        @click="guardarDatos">
          Imprimir
        </b-button>
        <b-button variant="outline-secondary" @click="$emit('cerrar')">
          Cancelar
        </b-button>
      </div>
    </b-modal>

  </div>
</template>


<script>


export default {
  name: 'configuracionPlazosPtiModal',
  components: {
  },
  props: {
    modalAbierto: Boolean,
    inversionTotal: Number,
    blnEntregable: Boolean,
    tituloModal: String
  },
  data : () => ({
    montoPagar: null,
    costoMsiTdc: [],
    configuracionesMsi: [],
    idPti: null,
    idSolicitud: null,
    idSesion: null,
    calculando: false,
    selectedMeses: [],
    fields: [
      {key: "meses", label: "Plazo"},
      {key: "pagoMensual", label: "Pago Mensual (aprox)"},
      {key: "costoFinanciamiento", label: "Costo de Financiamiento (iva incluido)"},
      {key: "total", label: "Total"}
    ],
  }),
  async created() {
    await this.obtenerConfiguracionPlazos();
    this.idPti = this.$route.params.idPti;
    this.idSolicitud = this.$route.params.idSolicitud;
    this.idSesion = this.$route.params.idSesion;
  },
  watch: {
    configuracionesMsi(value) {
      if (value.length > 0) {
        this.cargarDatos();
      }
    },
  },
  methods: {
    handleSelectedMeses(selectedMeses) {
      this.selectedMeses = this.sortSelectedMeses(selectedMeses);
    },
    sortSelectedMeses(selectedMeses) {
      return selectedMeses.slice().sort((a, b) => a.meses - b.meses);
    },
    truncarIva(x, posiciones){
      let s = x.toString()
      let l = s.length
      let decimalLength = s.indexOf('.') + l
      let numStr = s.substring(0, decimalLength + posiciones)
      return Number(numStr)
    },
    calcularMontosPlazoFijo() {
      this.costoMsiTdc = [];

      if (this.inversionTotal < this.montoPagar) {
        this.$bvToast.toast(
            'Su total de inversión es ' +
            new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(this.inversionTotal),
            {
              title: '¡El monto es mayor!',
              variant: 'danger',
              solid: false
            }
        );
      } else if (this.montoPagar === 0 || this.montoPagar === null) {
        this.$bvToast.toast("Ingrese un monto válido", {
          title: 'Su monto es cero',
          variant: 'warning',
          solid: false
        });
      } else {
        this.calculando = true;
        this.configuracionesMsi.forEach(item => {
          if (item.estatusMsi || item.aplicaCostoFinanciamiento) {
            let calculo = {};  // <-- ¡Ahora es un objeto!

            let financSinIva = 0;
            let totalFinanMasIVA = 0;
            let costoFinanciamiento = 0;
            let montoFinal = 0;

            if (this.montoPagar < item.montoMinimoMsi && !item.aplicaCostoFinanciamiento) {
              return;
            }

            if ((this.montoPagar >= item.montoMinimoMsi && item.estatusMsi) || !item.aplicaCostoFinanciamiento) {
              calculo.meses = item.meses;
              calculo.pagoMensual = Math.ceil(this.montoPagar / item.meses);
              calculo.idDetallePlazoFijo = item.idDetallePlazoFijo;
              calculo.costoFinanciamiento = 'Sin costo';
              calculo.total = this.montoPagar;
            } else {
              calculo.meses = item.meses;
              financSinIva = this.montoPagar * (item.porcentajeFinanciamiento / 100);
              totalFinanMasIVA = Math.ceil(financSinIva) * Number(0.16);
              let ivaTruncado = this.truncarIva(totalFinanMasIVA, 2);
              costoFinanciamiento = Number(Math.ceil(financSinIva)) + ivaTruncado;
              montoFinal = Number(costoFinanciamiento) + Number(this.montoPagar);
              calculo.idDetallePlazoFijo = item.idDetallePlazoFijo;
              calculo.pagoMensual = Math.ceil(montoFinal / item.meses);
              calculo.costoFinanciamiento = costoFinanciamiento;
              calculo.total = montoFinal;
            }

            this.costoMsiTdc.push(calculo);
          }
        });
        this.costoMsiTdc = Array.from(
            new Map(this.costoMsiTdc.map(item => [item.meses, item])).values()
        );
      }
    },

    async obtenerConfiguracionPlazos() {
      const params = { idClinica: this.$localStorageService.getIdClinica() }
      await this.$http.post(this.$api + "plazoFijo/obtenerDetalleMsi", params).then(response => {
            if (response.data.data) {
              this.configuracionesMsi = response.data.data;

              this.configuracionesMsi = this.configuracionesMsi.filter(msi => msi.registroActivo)
            }
          }
      )
    },
    async obtenerConfiguracionPlazosPti() {
      const params = { idPti: Number(this.$route.params.idPti) , idSolicitud: Number(this.$route.params.idSolicitud) , idSesion: Number(this.$route.params.idSesion) }
      await this.$http.post(this.$api + "plazoFijo/obtenerConfiguracionPti", params).then(response => {
            if (response.data.data) {
              let datosGuardados = response.data.data;
              if (datosGuardados !== null) {
                this.montoPagar = datosGuardados.montoFinanciar;
                this.calcularMontosPlazoFijo();
                this.selectedMeses = datosGuardados.mesesPlazoFijo;
              }
            }
          }
      )
    },
    filterJustNumber(e){
      const key = e.key;

      if (key === '-'){
        return e.preventDefault();
      }

      if (key === '+'){
        return e.preventDefault();
      }

      if (key === '.'){
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e'){
        return e.preventDefault();
      }

    },

    eliminarMonto(){
      this.calculando = false;
      this.costoMsiTdc = [];
      this.montoPagar = 0;
      this.selectedMeses = [];
    },

    guardarDatos() {
      const datos = {
        montoFinanciar: Number(this.montoPagar),
        mesesPlazoFijo: this.selectedMeses,
        idPti: Number(this.idPti),
        idSolicitud: Number(this.idSolicitud),
        idSesion: Number(this.idSesion),
      };

      if (this.blnEntregable === true){
        this.$emit('guardarOpcionAceptada', datos);
        this.$emit('cerrar');
        this.modalAbierto = false;
      }else {
        this.$http.post(this.$api + "plazoFijo/guardarConfiguracionPti", datos).then(response => {
          if (response.data.data) {
            this.$emit('guardarOpcionAceptada');
            this.$emit('cerrar');
            this.modalAbierto = false;
            this.$swal({
              icon: "success",
              title: "Éxito",
              text: "La Configuración de Plazos ha sido guardada con éxito",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        }).catch(error => {
          this.$swal({
            icon: "error",
            text: "No se ha podido guardar la configuración de los plazos",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          console.error(error);
          this.$emit('cerrar');
          this.modalAbierto = false;
        });
      }
    },

    cargarDatos() {
      this.obtenerConfiguracionPlazosPti();
    },

  }

}
</script>
<style scoped>
.modal-header{
  color: #053672 !important;
  background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}
</style>
